{{ 'pages.auth.help.question' | transloco }}
<a
  class="text-zinc-300 underline underline-offset-2 hover:text-zinc-100"
  href="https://incidite.com/contact"
  target="_blank"
  rel="noopener">
  {{ 'pages.auth.help.contactUs' | transloco }}
</a>
